import React from 'react';

import { useAPIFetchApplicationDescription } from '@marketplace/api';

import { DescriptionDataType, TPreviewImage } from '../../application.types';

import { ReadMore } from './read-more';


export function Overview(props: DescriptionDataType) {
  const { data, loaded, loading } = useAPIFetchApplicationDescription({
    applicationId: props.applicationId,
  });

  return (
    <>
      {loading && <div>Loading ...</div>}
      {loaded && data?.application_id && (
        <>
          <div className="overview-tab">
            <ReadMore>{data.long_description}</ReadMore>
          </div>
          <div className={data.preview_images.length === 5 ? "overview-tab__img-block img-center" : "overview-tab__img-block"}>
              {data.preview_images.length > 0 && data.preview_images.map((item: TPreviewImage) => 
                <div className="img-container" key={item.id}>
                  <img src={item.url} alt="" />
                </div>
              )}
            </div>
        </>
      )}
    </>
  );
}
